import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import {
  metersToFeet,
  getFormattedNumber
} from '../../../../../../../../common/utils'
import Status from '../status'

class LengthTable extends React.Component {
  constructor(props) {
    super(props)
  }

  lengthUnitConverter = (length) => {
    const { chartMeasurementUnit } = this.props
    if (chartMeasurementUnit === 'feet') {
      return metersToFeet(length)
    }
    return getFormattedNumber(length)
  }
  render() {
    const {
      fiberLengthData,
      translate,
      classes,
      chartMeasurementUnit
    } = this.props

    const measurementUnit = chartMeasurementUnit === 'feet' ? "" : `(${translate('m')})`
    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>{translate('fiber_result')}</TableCell>
            <TableCell numeric>{translate('fiber_refractiveindex')}</TableCell>
            <TableCell numeric>{translate('fiber_length')}{measurementUnit}</TableCell>
            <TableCell numeric>{translate('fiber_lengthlimit')}{measurementUnit}</TableCell>
            <TableCell numeric>{translate('fiber_lengthmargin')}{measurementUnit}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow >
            <TableCell>{fiberLengthData.teststatus ? (<React.Fragment> <Status status={fiberLengthData.teststatus} /></React.Fragment>) : (translate('general_na'))}</TableCell>
            <TableCell numeric>{fiberLengthData.refractiveindex}</TableCell>
            <TableCell numeric>{(fiberLengthData.cablelength !== null) ? this.lengthUnitConverter(fiberLengthData.cablelength) : (translate('general_na'))}</TableCell>
            <TableCell numeric>{this.lengthUnitConverter(fiberLengthData.lengthlimit)}</TableCell>
            <TableCell numeric>{this.lengthUnitConverter(fiberLengthData.lengthmargin)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(LengthTable)




// WEBPACK FOOTER //
// ./src/components/common/results/views/fiber/types/components/lengthdata/index.js